import { gql } from '@apollo/client'

const Address = {
  fragments: {
    address: gql`
      fragment Address on Address {
        company
        salutation
        firstName
        lastName
        streetAndNumber
        apartmentNumber
        zip
        city
        countryCode
      }
    `
  }
}

export default Address



// WEBPACK FOOTER //
// ./src/graphql/fragments/address/index.js